import { render, staticRenderFns } from "./PushTemplate.vue?vue&type=template&id=31269202&"
import script from "./PushTemplate.vue?vue&type=script&lang=ts&"
export * from "./PushTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports